import React from "react";
import "./CollapsibleTable.css";

export default function CollapsibleTable({
    columns = [],
    data = [],
    noScroll = false,
    onRowExpand = () => { },
}) {
    return (
        <div
            className="dtv2-wrapper"
            style={{
                overflowX: noScroll ? "visible" : "auto",
            }}
        >
            <table className="dtv2-table">
                <thead>
                    <tr>
                        {columns.map((col) => (
                            <th key={col.key} style={{ width: col.width || "auto" }}>
                                {col.label}
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {data.map((row, idx) => (
                        <React.Fragment key={idx}>
                            {/* MAIN ROW */}
                            <tr className={row._expanded ? "dtv2-row-expanded" : ""}>
                                {columns.map((col) => (
                                    <td key={col.key}>
                                        {col.render ? col.render(row[col.key], row) : row[col.key]}
                                    </td>
                                ))}
                            </tr>

                            {/* CHILD ROW */}
                            {row._expanded && (
                                <tr className="dtv2-child-row">
                                    <td colSpan={columns.length}>
                                        <div className="dtv2-child-content">
                                            {onRowExpand(row)}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
